import { Tooltip } from "@chakra-ui/react";

import { usePublicationStore } from "../store";
import { getIsPublic } from "../store/selectors";

export const LayerFromFileTooltip = ({
  label,
  children,
}: {
  label: string | undefined;
  children: React.ReactNode;
}) => {
  const isPublic = usePublicationStore(getIsPublic);

  // If the publication is public, we don't want to show a tooltip,
  // because it would be confusing to show a tooltip that says "Study area from file ..."
  // when the user cannot see the file.
  if (isPublic) return children;

  return (
    <Tooltip hasArrow placement="right" label={label}>
      {children}
    </Tooltip>
  );
};
